<template>
  <div>

    <div class="wrapper wrapper_mob">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 px-0">
          <b-tabs content-class="" class="user-bookings-tabs profile-tabs">
            <b-tab title="My Bookings" active>
              <div class="mt-lg-5 custom-shadow">
                <!-- <div class="filter-bookings">
                  <ul>
                    <li class="active">ALL</li>
                    <li>MOVIES</li>
                    <li>EVENTS</li>
                  </ul>
                </div> -->
                <div class="no-user-data-page" v-if="this.userBookingHistory.length == 0 && this.userBookingHistoryEvents.length == 0">No User History Found</div>
                <div
                  v-for="(data, index) in userBookingHistory"
                  :key="index"
                  class="mb-3 mb-lg-5"
                >
                  <div class="pb-lg-3 pb-2">
                    <span class="sm-font"
                      >Ticket Booking Date : {{ data.BookingDate }}
                      <!-- &nbsp; Confirmation ID:
                      878899900 -->
                    </span>
                  </div>
                  <div class="booking-card">
                    <div class="row">
                      <div class="col-lg-2">
                        <figure class="booking-card-img">
                          <img :src="data.Image" class="img-fluid" />
                        </figure>
                       
                      </div>
                      <div class="col-lg-6">
                        <div>
                          <h4 class="booking-card-title mb-0">
                            {{ data.Title }}
                          </h4>
                          <span class="sm-font">
                            {{ data.Language }} | {{ data.Format }} |
                            {{ data.Rated }} | {{ data.Runtime }}</span
                          >
                        </div>
                        <div class="booking-card-details my-lg-3 my-1">
                          <span>Show Date : {{ data.MovieDate }}</span>
                          <span>Show Time : {{ data.MovieTiming }}</span>
                          <span>Cinema Name : {{ data.CinemaName }}</span>
                          <span>Seats : {{ data.SeatsName }}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <span class="lg-font"
                            >Amount Paid : {{ data.Currency }}
                            {{ data.Total }}</span
                          >
                          <!-- <span class="lg-font"
                            ></span
                          > -->
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="booking-right-details">
                          <span class="sm-font">Booking ID</span>
                          <span class="lg-font text-pink">{{
                            data.BookingID
                          }}</span>
                          <hr/>
                          <div class="text-center">
                          <span class="sm-font">Payment Mode : </span> 
                          <span class="sm-font">{{ data.payment_mode }}</span>
                        </div>
                          <div class="qrDetails mt-1">
                            <img :src="data.QRCode" class="w-50 mb-3" alt />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-for="(data, index) in userBookingHistoryEvents"
                  :key="index"
                  class="mb-3 mb-lg-5"
                >
                  <div class="pb-lg-3 pb-2">
                    <span class="sm-font"
                      >Ticket Booking Date : {{moment(data.createdAt).format("YYYY-MM-DD h:mm A")}}
                      <!-- &nbsp; Confirmation ID:
                      878899900 -->
                    </span>
                  </div>
                  <div class="booking-card">
                    <div class="row">
                      <div class="col-lg-2">
                        <figure>
                          <img :src="baseUrlImg+data.e_image" class="img-fluid" />
                        </figure>
                       
                      </div>
                      <div class="col-lg-6">
                        <div>
                          <h4 class="booking-card-title mb-0">
                            {{ data.event_name }}
                          </h4>
                          <span class="sm-font">
                            {{ data.e_s_description }}</span
                          >
                        </div>
                        <div class="booking-card-details my-lg-3 my-1">
                          <span>Show Date : {{ moment(data.es_date).format("DD MMMM,YYYY") }}</span>
                          <span>Show Time : {{ moment(data.es_time, "h:mm A").format("h:mm A") }} </span>
                          <span>Cinema Name : {{ data.ev_address }}</span>
                          <span>Seats : {{ data.ticket_sub_cat }}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                          <span class="lg-font"
                            >Amount Paid : {{ data.currency }}
                            {{ data.total_price }}</span
                          >
                          <!-- <span class="lg-font"
                            ></span
                          > -->
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="booking-right-details">
                          <!-- <div class="qrDetails mt-1">
                            <qrcode-vue :value="data.event_booked_id" :size="size" level="H" />
                          </div> -->
                          <span class="sm-font">Booking ID</span>
                          <span class="lg-font text-pink">{{
                            data.event_booked_id
                          }}</span>
                          <hr/>
                          <div class="text-center">
                          <span class="sm-font">Payment Mode : </span>
                          <span class="sm-font" v-if="data.purchase_mode == 1">Credit Card</span>
                          <span class="sm-font" v-if="data.purchase_mode == 2">Debit Card</span>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
           
          </b-tabs>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { EVENT_URL } from "@/helper/constant.js";
import moment from "moment";
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {
      userBookingHistory: [],
      userBookingHistoryEvents: [],
      baseUrlImg:'https://adminapi-wanastime.wanasatime.com/uploads',
      value: '',
      size: 100,
      moment,
      moviesData: [
        "Urban",
        "Thriller",
        "Speculative",
        "Slice",
        "Of",
        "Life",
        "Science-Fiction",
        "Satire",
        "Saga",
        "Romance",
        "Philosophical",
        "Paranoid",
        "Musical",
        "Mystery",
        "Horror",
        "Historical",
        "Fantasy",
        "Family",
        "Erotica",
        "Documentary",
        "Drama",
        "Crime",
        "Comedy",
        "Biography",
        "Animation",
        "Adventure",
        "Action"
      ],
      eventsData: [
        "Class",
        "Seminar",
        "Sales and Marketing",
        "Finance",
        "StartUps",
        "Educators",
        "Dance",
        "Music",
        "Dinning and Music Concerts",
        " Food and Drink",
        " Exhibitions"
      ],
      langugageData: [
        "English",
        "Philipino",
        "Kannada",
        "Arabic",
        "Oriya",
        "Malayalam",
        "Punjabi",
        "Chinese",
        "Hindi (Dubbed)",
        "Norweaian",
        "Thai",
        "Tamil"
      ],
      url: EVENT_URL,
    };
  },
  beforeMount() {
    this.getBookingHistory();
    this.getBookingHistoryEvents();
  },
  components: {
    QrcodeVue,
  },
  methods: {
    getBookingHistory: function() {
      // this.showLoading();
      makeRequest("/GetBookingHistory", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (!error && res.data.Status) {
            this.userBookingHistory = res.data.List;
          }
          this.hideLoading();
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
    getBookingHistoryEvents: function() {
      let that = this;
      // this.showLoading();
      makeRequest(
        "/v1/booking/history/",
        "POST",
        null,
        null,
        EVENT_URL,
        false
      )
        .then(response => {
          that.loading = false;
          const { error, res } = response;
          console.log(res.data.data,"respo")
          this.userBookingHistoryEvents = res.data.data;
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
        });
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/userBookings.vue